import {
    Clock,
    FileText,
    GitBranch,
    Layers,
    RefreshCw,
    RotateCcw,
    ShieldCheck,
    Database as StorageIcon,
    UserCheck,
    Webhook
} from 'lucide-react';
import type { CustomNodeProps } from '../../types/nodes';
import {
    ApprovalConfig,
    ParallelConfig,
    RetryConfig,
    StorageConfig,
    SwitchConfig,
    ValidatorConfig,
    WebhookListenerConfig
} from './AdvancedNodeConfigs';
import { BaseNode } from './BaseNode';
import { LoggerConfig } from './LoggerConfig';
import { LoopConfig } from './LoopConfig';
import { WaitConfig } from './WaitConfig';
import { WebhookCallerConfig } from './WebhookCallerConfig';

export function LoopNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={RefreshCw}
      configComponent={LoopConfig}
    />
  );
}

export function WaitNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={Clock}
      configComponent={WaitConfig}
    />
  );
}

export function WebhookListenerNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={Webhook}
      configComponent={WebhookListenerConfig}
    />
  );
}

export function ApprovalNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={UserCheck}
      configComponent={ApprovalConfig}
    />
  );
}

export function LoggerNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={FileText}
      configComponent={LoggerConfig}
    />
  );
}

export function ValidatorNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={ShieldCheck}
      configComponent={ValidatorConfig}
    />
  );
}

export function StorageNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={StorageIcon}
      configComponent={StorageConfig}
    />
  );
}

export function WebhookCallerNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={Webhook}
      configComponent={WebhookCallerConfig}
    />
  );
}

export function SwitchNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={GitBranch}
      configComponent={SwitchConfig}
    />
  );
}

export function RetryNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={RotateCcw}
      configComponent={RetryConfig}
    />
  );
}

export function ParallelNode(props: CustomNodeProps) {
  if (props.data.category !== 'advanced') return null;
  
  return (
    <BaseNode
      {...props}
      icon={Layers}
      configComponent={ParallelConfig}
    />
  );
} 